var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/lodash/_Set.js